import { Button, css, Dialog as MuiDialog, DialogContent, DialogTitle, Link, styled, Typography } from '@mui/material';

import { useUserStore } from '@/stores/useUserStore';

const StyledDialog = styled(MuiDialog)(
  ({ theme }) => css`
    & .MuiDialog-paper {
      border-radius: ${theme.spacing(1)};
      background-color: ${theme.palette.common.white};
      box-shadow: ${theme.shadows[2]};
      padding: ${theme.spacing(1)};
      align-items: flex-start;
    }
  `,
);

export function Dialog() {
  const dialogVisible = useUserStore((state) => state.dialogVisible);
  const { setDialogVisible } = useUserStore((state) => state.actions);

  const handleClose = (event?: HTMLButtonElement  , reason?: string) => {
    if (reason !== 'backdropClick') {
      setDialogVisible(false);
    }
  };

  return (
    <StyledDialog maxWidth="sm" open={dialogVisible}>
      <DialogTitle component="div">
        <Typography variant="h3">Herzlich Willkommen!</Typography>
      </DialogTitle>
      <DialogContent sx={{ alignItems: { xs: 'center', md: 'flex-start' }, textAlign: { xs: 'center', md: 'start' } }}>
        <Typography mb={2}>
          Dieses Webportal ist ein Auskunftssystem für die Routenberechnung für Einsatzkräfte und den motorisierten
          Individualverkehr, welches als Forschungsdemonstrator im{' '}
          <Link
            href="https://mcube-cluster.de/projekt/datsim-2-0/"
            rel="noopener noreferrer"
            sx={{ color: 'primary.dark', fontSize: '1.125rem' }}
            target="_blank"
          >
            mCube Projekt DatSIM 2.0
          </Link>{' '}
          umgesetzt wurde. Der Untersuchungsraum bezieht sich auf das Stadtgebiet von München.
        </Typography>

        <Button onClick={() => handleClose()} size="large" sx={{ mb: 1.5 }} variant="contained">
          Jetzt starten
        </Button>
      </DialogContent>
    </StyledDialog>
  );
}
